import { twMerge } from 'tailwind-merge'

type Props = {
  label?: string
  show?: boolean
  size?: string
} & ((React.ComponentPropsWithoutRef<'div'>))

export function Loading({ show, label, size, className }: Props) {
  return (
    <div className={
      twMerge(
        'text-center transition duration-300 z-20',
        className,
        show ? 'block' : 'hidden',
      )
    }>
      <svg className={`animate-spin text-zinc-800 dark:text-zinc-300 ${size || 'w-20'} `}
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      {
        label && <div className='mt-4 text-zinc-800 dark:text-zinc-300 text-sm font-normal'>{label}</div>
      }
    </div>
  )
}

export function PageLoading({ className, show }: { className?: string, show: boolean }) {
  return (
    <div className={twMerge('w-fit z-10 mx-auto absolute top-12 right-0 left-0', className, !show && 'hidden')}>
      <div className='rounded-full bg-white dark:bg-zinc-200 p-2 m-auto shadow-lg'>
        <svg className='animate-spin text-red-800 w-10' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
          <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
          <path fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>
        </svg>
      </div>
    </div>
  )
}